<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <Tabs class="router-view" :animated="false" v-model="active">
                <TabPane label="消息公告" :index="1" name="messageIndex">
                    <Access name="messageIndex">
                        <router-view
                            v-if="active == 'messageIndex'"
                            :name="$access.aliasToUri('messageIndex')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="广告设置" :index="2" name="noticeIndex">
                    <Access name="noticeIndex">
                        <router-view
                            v-if="active == 'noticeIndex'"
                            :name="$access.aliasToUri('noticeIndex')"
                        ></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            active: 'messageIndex'
        }
    }
}
</script>
